import { ISearchFilters } from "../common/api_interfaces/search/ISearchFilters";
import { ISearchRequest } from "../common/api_interfaces/search/ISearchRequest";
import $api from "../index";
import { ISearchResult } from "../common/api_interfaces/search/ISearchResult";

export class SearchService {
    async search(body: ISearchRequest) {
        return await $api.post<ISearchResult>(`/search`, body);
    }

    async lightSearch(searchStr: string) {
        return await $api.get<ISearchResult>(`/search?qt=${searchStr}`);
    }

    async getFilters() {
        return await $api.get<ISearchFilters>("/search/filters")
    }
}
